import io from "socket.io-client";
import { apiSlice } from "../api/apiSlice";
import { messagesApi } from "../messages/messagesApi";

export const conversationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConversations: builder.query({
      query: (email) =>
        `/conversations?participants_like=${email}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_CONVERSATIONS_PER_PAGE}`,
      transformResponse(apiResponse, meta) {
        const totalCount = meta.response.headers.get("X-Total-Count");
        return {
          data: apiResponse,
          totalCount,
        };
      },
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
      ) {
        // create socket
        const socket = io("https://mamun-chat-server.herokuapp.com", {
          reconnectionDelay: 1000,
          reconnection: true,
          reconnectionAttemps: 10,
          transports: ["websocket"],
          agent: false,
          upgrade: false,
          rejectUnauthorized: false,
        });

        try {
          await cacheDataLoaded;
          socket.on("conversation", (data) => {
            // console.log(JSON.stringify(data?.data));
            updateCachedData((draft) => {
              console.log(
                `this is all conversation data ${JSON.stringify(draft)}`
              );
              const conversation = draft.data.find(
                (c) => c?.id == data?.data?.id
              );
              // console.log(
              //   JSON.stringify(`this is conversation ${conversation}`)
              // );

              if (conversation?.id) {
                conversation.message = data?.data?.message;
                conversation.timestamp = data?.data?.timestamp;
              } else if (!conversation?.id) {
                draft.data.push(data?.data);
                // do nothing
              }
            });
          });
        } catch (err) {}

        // await cacheEntryRemoved;
        // socket.close();
      },
    }),
    getMoreConversations: builder.query({
      query: ({ email, page }) =>
        `/conversations?participants_like=${email}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_CONVERSATIONS_PER_PAGE}`,
      async onQueryStarted({ email }, { queryFulfilled, dispatch }) {
        try {
          const conversations = await queryFulfilled;
          if (conversations?.data?.length > 0) {
            // update conversation cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData(
                "getConversations",
                email,
                (draft) => {
                  return {
                    data: [...draft.data, ...conversations.data],
                    totalCount: Number(draft.totalCount),
                  };
                }
              )
            );
            // update messages cache pessimistically end
          }
        } catch (err) {}
      },
    }),
    getConversation: builder.query({
      query: ({ userEmail, participantEmail }) =>
        `/conversations?participants_like=${userEmail}-${participantEmail}&&participants_like=${participantEmail}-${userEmail}`,
    }),
    addConversation: builder.mutation({
      query: ({ sender, data }) => ({
        url: "/conversations",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const conversation = await queryFulfilled;
        console.log(
          `this is add conversation data ${JSON.stringify(conversation?.data)}`
        );
        const addCoversation = dispatch(
          apiSlice.util.updateQueryData(
            "getConversations",
            arg?.sender,
            (draft) => {
              const foundMsg = draft.data.findIndex(
                (msg) => msg.timestamp === arg?.data?.timestamp
              );
              if (foundMsg === -1) draft.data.push(conversation?.data);
              // draft.data.push(conversation?.data);
              // console.log(
              //   `this is add conversation draft data ${JSON.stringify(
              //     draft.data
              //   )}`
              // );
              // draft.data.push(conversation?.data);
            }
          )
        );
        try {
          if (conversation?.data?.id) {
            // silent entry to message table
            const users = arg.data.users;
            const senderUser = users.find((user) => user.email === arg.sender);
            const receiverUser = users.find(
              (user) => user.email !== arg.sender
            );

            dispatch(
              messagesApi.endpoints.addMessage.initiate({
                conversationId: conversation?.data?.id,
                sender: senderUser,
                receiver: receiverUser,
                message: arg.data.message,
                timestamp: arg.data.timestamp,
              })
            );
          }
        } catch (error) {
          addCoversation.undo();
        }
      },
    }),
    editConversation: builder.mutation({
      query: ({ id, data, sender }) => ({
        url: `/conversations/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const conversation = await queryFulfilled;
        const pathResult = dispatch(
          apiSlice.util.updateQueryData(
            "getConversations",
            arg?.sender,
            (draft) => {
              // const foundMsg = draft.data.findIndex(
              //   (msg) => msg.id === arg?.data?.id
              // );
              // if (foundMsg === -1) foundMsg.data = conversation?.data;
              const draftConversation = draft.data.find(
                (c) => c.id == arg?.id.toString()
              );
              if (draftConversation?.id) {
                draftConversation.message = arg?.data?.message;
                draftConversation.timestamp = arg?.data?.timestamp;
              }
              console.log(
                `this is edit conversation draft data ${JSON.stringify(
                  draft.data
                )}`
              );
            }
          )
        );
        // optimistic cache update end

        try {
          if (conversation?.data?.id) {
            // silent entry to message table
            const users = arg?.data?.users;
            const senderUser = users.find((user) => user.email === arg.sender);
            const receiverUser = users.find(
              (user) => user.email !== arg.sender
            );

            const res = await dispatch(
              messagesApi.endpoints.addMessage.initiate({
                conversationId: conversation?.data?.id,
                sender: senderUser,
                receiver: receiverUser,
                message: arg?.data?.message,
                timestamp: arg?.data?.timestamp,
              })
            ).unwrap();

            // update messages cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData(
                "getMessages",
                res.conversationId.toString(),
                (draft) => {
                  const foundMsg = draft.data.findIndex(
                    (msg) => msg.timestamp === res?.timestamp
                  );
                  if (foundMsg === -1) draft.data.push(res);
                }
              )
            );
            // update messages cache pessimistically end
          }
        } catch (err) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetConversationsQuery,
  useGetConversationQuery,
  useAddConversationMutation,
  useEditConversationMutation,
} = conversationsApi;
